var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileicon = function SvgMobileicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.333.667h5.334a2 2 0 0 1 2 2v10.666a2 2 0 0 1-2 2H5.333a2 2 0 0 1-2-2V2.667a2 2 0 0 1 2-2Zm0 13.333h5.334a.667.667 0 0 0 .666-.667V2.667a.667.667 0 0 0-1.333 0 .667.667 0 0 1-.667.666H6.667A.667.667 0 0 1 6 2.667a.667.667 0 0 0-1.333 0v10.666c0 .368.298.667.666.667Z",
    clipRule: "evenodd"
  })));
};
export default SvgMobileicon;